import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-short-weave-loader',
    templateUrl: './short-weave-loader.component.html',
    styleUrls: ['./short-weave-loader.component.scss']
})
export class ShortWeaveLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
